export default function PageHeading(props) {
    const subTitleChildrenClassNames = "[&_a]:inline-flex [&_a]:items-center [&_a]:gap-1 [&_a]:font-bold [&_a]:text-inherit [&_a]:no-underline [&_a]:transition-[color,opacity] [&_a]:duration-200 [&_a::after]:content-['↗'] [&_a::after]:font-sans [&_a::after]:text-[0.75em] [&_a::after]:leading-none [&_a::after]:-translate-y-[0.08em] [&_a::after]:transition-transform [&_a::after]:duration-200 [&_a:hover]:text-white [&_a:hover]:opacity-80 [&_a:hover::after]:translate-x-[0.12em] [&_a:hover::after]:-translate-y-[0.2em] [&_a:focus-visible]:rounded [&_a:focus-visible]:outline [&_a:focus-visible]:outline-2 [&_a:focus-visible]:outline-offset-[3px] [&_a:focus-visible]:outline-white/75";
    const isLeftAligned = props.align === 'left';
    const isCenteredOnMobile = isLeftAligned && props.mobileAlign === 'center';
    const containerAlignment = isCenteredOnMobile
        ? 'items-center text-center md:items-start md:text-left'
        : isLeftAligned
            ? 'items-start text-left'
            : 'items-center text-center';
    const titleAlignment = isCenteredOnMobile
        ? 'text-center md:text-left'
        : isLeftAligned
            ? 'text-left'
            : 'text-center';

    return (
        <header
            className={`w-full flex flex-col gap-3 sm:gap-6 text-white ${containerAlignment} ${props.className || ''}`}
        >
            <h1
                className={`font-display font-black text-4xl sm:text-5xl 2xl:text-7xl ${titleAlignment}`}
                dangerouslySetInnerHTML={{ __html: props.title }}
            />
            {props.showSeparator !== false && <Separator />}
            {props.subTitle && (
                <h2 className={`w-full max-w-[720px] ${subTitleChildrenClassNames}`}>
                    {props.subTitle}
                </h2>
            )}
        </header>
    );
}

function Separator() {
    return (
        <div className='pointer-events-none select-none flex gap-1.5 p-1 bg-white/10 rounded-full'>
            <div className='size-3 gradient-yellow rounded-full shadow ' />
            <div className='size-3 gradient-blue rounded-full shadow ' />
            <div className='size-3 gradient-green rounded-full shadow' />
        </div>
    );
}
